import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "tile is-ancestor" }
const _hoisted_3 = { class: "tile is-parent is-vertical" }
const _hoisted_4 = { class: "tile is-child statistics__content" }
const _hoisted_5 = { class: "card has-mobile-sort-spaced" }
const _hoisted_6 = { class: "statistics__loading-overlay" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("header", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "card-header-title" }, " Estadísticos de Cumplimiento de Transparencia Activa ")
], -1)
const _hoisted_8 = { class: "card-content statistics_graph-group" }
const _hoisted_9 = { class: "statistics__compliance-per-entity is-flex is-flex-wrap-wrap is-justify-content-space-evenly" }
const _hoisted_10 = { class: "statistics__compliance-percentage is-flex is-flex-wrap-wrap is-justify-content-space-around" }
const _hoisted_11 = { class: "card has-mobile-sort-spaced" }
const _hoisted_12 = { class: "statistics__loading-overlay" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("header", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "card-header-title" }, " Estadísticos de solicitudes de información por la plataforma y calificación de satisfacción ")
], -1)
const _hoisted_14 = { class: "card-content statistics_graph-group" }
const _hoisted_15 = { class: "statistics__citizen-statistics is-flex is-flex-wrap-wrap is-justify-content-space-evenly" }
const _hoisted_16 = { class: "card has-mobile-sort-spaced" }
const _hoisted_17 = { class: "statistics__loading-overlay" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("header", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "card-header-title" }, "Estadísticos Ciudadana")
], -1)
const _hoisted_19 = { class: "card-content statistics_graph-group" }
const _hoisted_20 = { class: "statistics__citizen-statistics is-flex is-flex-wrap-wrap is-justify-content-space-evenly" }
const _hoisted_21 = { class: "card has-mobile-sort-spaced" }
const _hoisted_22 = { class: "statistics__loading-overlay" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("header", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "card-header-title" }, " Base de Datos de Oficiales de Información ")
], -1)
const _hoisted_24 = { class: "card-content is-flex" }

import CompliancePieChart from "@/components/statistics/CompliancePieChart.vue";
import BarChart from "@/components/statistics/BarChart.vue";
import CompliancePercentageBarChart from "@/components/statistics/CompliancePercentageBarChart.vue";
import { ref, onMounted, watch } from "vue";
import MonthPicker from "@/components/common/month-picker/MonthPicker.vue";
import ExportButtons from "@/components/common/ExportButtons.vue";
import { statisticsService } from "@/services";
import SvgIcon from "@jamescoyle/vue-icon";
import { mdiReload } from "@mdi/js";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const now = new Date();
const loading = ref(false);
const currentPeriod = ref({
  monthIndex: 0,
  year: 0,
});
const compliantVsNonCompliantInstitutions = ref({
  compliant: 0,
  nonCompliant: 0,
});
const compliantVsNonCompliantMunicipalities = ref({
  compliant: 0,
  nonCompliant: 0,
});
const compliantVsNonCompliantCommunalBoards = ref({
  compliant: 0,
  nonCompliant: 0,
});
const compliancePercentagePerInstitutions = ref({
  entities: [],
  annual: [],
  monthly: [],
});
const compliancePercentagePerMunicipalities = ref({
  entities: [],
  annual: [],
  monthly: [],
});

const compliancePercentagePerCommunalBoards = ref({
  entities: [],
  annual: [],
  monthly: [],
});

const solicitantPerGender = ref({ male: 0, female: 0, unknown: 0 });
const solicitantWithDisabilityPerGender = ref({ male: 0, female: 0 });
const solicitantPerEthnicity = ref({ ethnicities: [], counts: [] });
const solicitantPerProvince = ref({ provinces: [], counts: [] });
const requestsPerStateType = ref({ states: [], counts: [] });
const meanRequestScorePerEntity = ref({ entities: [], means: [] });

const entitiesRequestsScoreAverageXlsxExportLink = ref("");
const entitiesRequestsScoreAverageCsvExportLink = ref("");
const entitiesRequestsScoreAveragePdfExportLink = ref("");
const institutionAdminReportListXlsxExportLink = ref("");
const institutionAdminReportListCsvExportLink = ref("");
const institutionAdminReportListPdfExportLink = ref("");
const complianceByInstitutionXlsxExportLink = ref("");
const complianceByInstitutionCsvExportLink = ref("");
const complianceByInstitutionPdfExportLink = ref("");
const complianceByMunicipalityXlsxExportLink = ref("");
const complianceByMunicipalityCsvExportLink = ref("");
const complianceByMunicipalityPdfExportLink = ref("");
const complianceByCommunalBoardXlsxExportLink = ref("");
const complianceByCommunalBoardCsvExportLink = ref("");
const complianceByCommunalBoardPdfExportLink = ref("");

const previousMonthDate = ref(null);

function setCurrentPeriod() {
  const now = new Date();
  currentPeriod.value = {
    monthIndex: now.getMonth(),
    year: now.getFullYear(),
  };

  now.setMonth(now.getMonth() - 1);
  previousMonthDate.value = now;
}

async function getStatistics(month: number, year: number) {
  try {
    loading.value = true;
    const requestsStatistics =
      await statisticsService.getPublicRequestsStatistics(month, year);

    solicitantPerGender.value = requestsStatistics.solicitantPerGender;
    solicitantWithDisabilityPerGender.value =
      requestsStatistics.solicitantWithDisabilityPerGender;
    solicitantPerEthnicity.value = requestsStatistics.solicitantPerEthnicity;
    solicitantPerProvince.value = requestsStatistics.solicitantPerProvince;
    requestsPerStateType.value = {
      states: requestsStatistics.requestsPerStateType.states,
      counts: requestsStatistics.requestsPerStateType.perType.map((x) => ({
        data: x.counts,
        label: x.type,
      })),
    };
    meanRequestScorePerEntity.value =
      requestsStatistics.meanRequestScorePerEntity;

    const stats = await statisticsService.getPublicComplianceStatistics(
      month,
      year
    );

    compliantVsNonCompliantInstitutions.value =
      stats.compliantVsNonCompliantInstitutions;
    compliantVsNonCompliantMunicipalities.value =
      stats.compliantVsNonCompliantMunicipalities;
    compliantVsNonCompliantCommunalBoards.value =
      stats.compliantVsNonCompliantCommunalBoards;
    compliancePercentagePerInstitutions.value =
      stats.compliancePercentagePerInstitutions;
    compliancePercentagePerMunicipalities.value =
      stats.compliancePercentagePerMunicipalities;
    compliancePercentagePerCommunalBoards.value =
        stats.compliancePercentagePerCommunalBoards

    entitiesRequestsScoreAverageXlsxExportLink.value =
      statisticsService.getExportLink(
        "entities_requests_score_average",
        month,
        year,
        "xlsx"
      );

    entitiesRequestsScoreAverageCsvExportLink.value =
      statisticsService.getExportLink(
        "entities_requests_score_average",
        month,
        year,
        "csv"
      );

    entitiesRequestsScoreAveragePdfExportLink.value =
      statisticsService.getExportLink(
        "entities_requests_score_average",
        month,
        year,
        "pdf"
      );

    institutionAdminReportListXlsxExportLink.value =
      statisticsService.getExportLink(
        "institution_admin_report_list",
        month,
        year,
        "xlsx"
      );

    institutionAdminReportListCsvExportLink.value =
      statisticsService.getExportLink(
        "institution_admin_report_list",
        month,
        year,
        "csv"
      );

    institutionAdminReportListPdfExportLink.value =
      statisticsService.getExportLink(
        "institution_admin_report_list",
        month,
        year,
        "pdf"
      );

    complianceByInstitutionXlsxExportLink.value =
      statisticsService.getExportLink(
        "entities_with_compliance_percentage_by_institution",
        month,
        year,
        "xlsx"
      );

    complianceByInstitutionCsvExportLink.value =
      statisticsService.getExportLink(
        "entities_with_compliance_percentage_by_institution",
        month,
        year,
        "csv"
      );

    complianceByInstitutionPdfExportLink.value =
      statisticsService.getExportLink(
        "entities_with_compliance_percentage_by_institution",
        month,
        year,
        "pdf"
      );

    complianceByMunicipalityXlsxExportLink.value =
      statisticsService.getExportLink(
        "entities_with_compliance_percentage_by_municipality",
        month,
        year,
        "xlsx"
      );

    complianceByMunicipalityCsvExportLink.value =
      statisticsService.getExportLink(
        "entities_with_compliance_percentage_by_municipality",
        month,
        year,
        "csv"
      );

    complianceByMunicipalityPdfExportLink.value =
      statisticsService.getExportLink(
        "entities_with_compliance_percentage_by_municipality",
        month,
        year,
        "pdf"
      );


    complianceByCommunalBoardXlsxExportLink.value =
        statisticsService.getExportLink(
            "entities_with_compliance_percentage_by_municipality",
            month,
            year,
            "xlsx"
        );

    complianceByCommunalBoardCsvExportLink.value =
        statisticsService.getExportLink(
            "entities_with_compliance_percentage_by_municipality",
            month,
            year,
            "csv"
        );

    complianceByCommunalBoardPdfExportLink.value =
        statisticsService.getExportLink(
            "entities_with_compliance_percentage_by_municipality",
            month,
            year,
            "pdf"
        );

  } finally {
    loading.value = false;
  }
}

watch(currentPeriod, (curr) => {
  getStatistics(curr.monthIndex, curr.year);
});

onMounted(async () => {
  setCurrentPeriod();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(MonthPicker, {
            modelValue: currentPeriod.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((currentPeriod).value = $event)),
            "max-date": previousMonthDate.value
          }, null, 8, ["modelValue", "max-date"]),
          _createElementVNode("div", _hoisted_5, [
            _withDirectives(_createElementVNode("div", _hoisted_6, [
              _createVNode(_unref(SvgIcon), {
                class: "rotate-infinite",
                type: "mdi",
                path: _unref(mdiReload)
              }, null, 8, ["path"])
            ], 512), [
              [_vShow, loading.value]
            ]),
            _hoisted_7,
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createVNode(CompliancePieChart, {
                  title: 'Cumplimiento de Instituciones',
                  compliant: compliantVsNonCompliantInstitutions.value.compliant,
                  "non-compliant": 
                    compliantVsNonCompliantInstitutions.value.nonCompliant
                  
                }, null, 8, ["compliant", "non-compliant"]),
                _createVNode(CompliancePieChart, {
                  title: 'Cumplimiento de Municipios',
                  compliant: compliantVsNonCompliantMunicipalities.value.compliant,
                  "non-compliant": 
                    compliantVsNonCompliantMunicipalities.value.nonCompliant
                  
                }, null, 8, ["compliant", "non-compliant"]),
                _createVNode(CompliancePieChart, {
                  title: 'Cumplimiento de Juntas Comunales',
                  compliant: compliantVsNonCompliantCommunalBoards.value.compliant,
                  "non-compliant": 
                    compliantVsNonCompliantCommunalBoards.value.nonCompliant
                  
                }, null, 8, ["compliant", "non-compliant"])
              ]),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", null, [
                  _createVNode(CompliancePercentageBarChart, {
                    title: 'Porcentaje de cumplimiento por Institución',
                    annual: compliancePercentagePerInstitutions.value.annual,
                    monthly: compliancePercentagePerInstitutions.value.monthly,
                    entities: compliancePercentagePerInstitutions.value.entities
                  }, null, 8, ["annual", "monthly", "entities"]),
                  _createVNode(ExportButtons, {
                    xlsxUrl: complianceByInstitutionXlsxExportLink.value,
                    csvUrl: complianceByInstitutionCsvExportLink.value,
                    pdfUrl: complianceByInstitutionPdfExportLink.value,
                    label: "Descargar completo"
                  }, null, 8, ["xlsxUrl", "csvUrl", "pdfUrl"])
                ]),
                _createElementVNode("div", null, [
                  _createVNode(CompliancePercentageBarChart, {
                    title: 'Porcentaje de cumplimiento por Municipio',
                    annual: compliancePercentagePerMunicipalities.value.annual,
                    monthly: compliancePercentagePerMunicipalities.value.monthly,
                    entities: compliancePercentagePerMunicipalities.value.entities
                  }, null, 8, ["annual", "monthly", "entities"]),
                  _createVNode(ExportButtons, {
                    xlsxUrl: complianceByMunicipalityXlsxExportLink.value,
                    csvUrl: complianceByMunicipalityCsvExportLink.value,
                    pdfUrl: complianceByMunicipalityPdfExportLink.value,
                    label: "Descargar completo"
                  }, null, 8, ["xlsxUrl", "csvUrl", "pdfUrl"])
                ]),
                _createElementVNode("div", null, [
                  _createVNode(CompliancePercentageBarChart, {
                    title: 'Porcentaje de cumplimiento por Junta Comunal',
                    annual: compliancePercentagePerCommunalBoards.value.annual,
                    monthly: compliancePercentagePerCommunalBoards.value.monthly,
                    entities: compliancePercentagePerCommunalBoards.value.entities
                  }, null, 8, ["annual", "monthly", "entities"]),
                  _createVNode(ExportButtons, {
                    xlsxUrl: complianceByCommunalBoardXlsxExportLink.value,
                    csvUrl: complianceByCommunalBoardCsvExportLink.value,
                    pdfUrl: complianceByCommunalBoardPdfExportLink.value,
                    label: "Descargar completo"
                  }, null, 8, ["xlsxUrl", "csvUrl", "pdfUrl"])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _withDirectives(_createElementVNode("div", _hoisted_12, [
              _createVNode(_unref(SvgIcon), {
                class: "rotate-infinite",
                type: "mdi",
                path: _unref(mdiReload)
              }, null, 8, ["path"])
            ], 512), [
              [_vShow, loading.value]
            ]),
            _hoisted_13,
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                _createVNode(BarChart, {
                  title: 'Solicitudes recibidas por estado y tipo',
                  data: requestsPerStateType.value.counts,
                  label: requestsPerStateType.value.states
                }, null, 8, ["data", "label"]),
                _createElementVNode("div", null, [
                  _createVNode(BarChart, {
                    title: 'Promedio de Calificación por Entidad',
                    data: meanRequestScorePerEntity.value.means,
                    label: meanRequestScorePerEntity.value.entities,
                    horizontal: ""
                  }, null, 8, ["data", "label"]),
                  _createVNode(ExportButtons, {
                    xlsxUrl: entitiesRequestsScoreAverageXlsxExportLink.value,
                    csvUrl: entitiesRequestsScoreAverageCsvExportLink.value,
                    pdfUrl: entitiesRequestsScoreAveragePdfExportLink.value,
                    label: "Descargar completo"
                  }, null, 8, ["xlsxUrl", "csvUrl", "pdfUrl"])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_16, [
            _withDirectives(_createElementVNode("div", _hoisted_17, [
              _createVNode(_unref(SvgIcon), {
                class: "rotate-infinite",
                type: "mdi",
                path: _unref(mdiReload)
              }, null, 8, ["path"])
            ], 512), [
              [_vShow, loading.value]
            ]),
            _hoisted_18,
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("div", _hoisted_20, [
                _createVNode(BarChart, {
                  title: 'Personas solicitantes por género',
                  data: [
                    solicitantPerGender.value.male,
                    solicitantPerGender.value.female,
                    solicitantPerGender.value.unknown,
                  ],
                  label: ['Masculino', 'Femenino', 'N/A']
                }, null, 8, ["data"]),
                _createVNode(BarChart, {
                  title: 'Personas solicitantes con discapacidad por género',
                  data: [
                    solicitantWithDisabilityPerGender.value.male,
                    solicitantWithDisabilityPerGender.value.female,
                  ],
                  label: ['Masculino', 'Femenino']
                }, null, 8, ["data"]),
                _createVNode(BarChart, {
                  title: 'Personas solicitantes por etnia',
                  label: solicitantPerEthnicity.value.ethnicities,
                  data: solicitantPerEthnicity.value.counts
                }, null, 8, ["label", "data"]),
                _createVNode(BarChart, {
                  title: 'Personas solicitantes por provincia',
                  label: solicitantPerProvince.value.provinces,
                  data: solicitantPerProvince.value.counts
                }, null, 8, ["label", "data"])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_21, [
            _withDirectives(_createElementVNode("div", _hoisted_22, [
              _createVNode(_unref(SvgIcon), {
                class: "rotate-infinite",
                type: "mdi",
                path: _unref(mdiReload)
              }, null, 8, ["path"])
            ], 512), [
              [_vShow, loading.value]
            ]),
            _hoisted_23,
            _createElementVNode("div", _hoisted_24, [
              _createVNode(ExportButtons, {
                xlsxUrl: institutionAdminReportListXlsxExportLink.value,
                csvUrl: institutionAdminReportListCsvExportLink.value,
                pdfUrl: institutionAdminReportListPdfExportLink.value,
                label: "Descargar completo"
              }, null, 8, ["xlsxUrl", "csvUrl", "pdfUrl"])
            ])
          ])
        ])
      ])
    ])
  ]))
}
}

})